import React, { useEffect, useState } from 'react';

import './CountdownTimer.css';

const parseTime = (startTime) => {
  const diffTime = startTime - Math.trunc(Date.now() / 1000);
  if (diffTime < 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  const seconds = diffTime % 60;
  const rawMinutes = (diffTime - seconds) / 60;
  const minutes = rawMinutes % 60;
  const rawHours = (rawMinutes - minutes) / 60;
  const hours = rawHours % 24;
  const days = (rawHours - hours) / 24;

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

const CountdownTimer = ({ startTime }) => {
  const [isClient, setIsClient] = useState(false);

  const [timer, setTimer] = useState(() => {
    if (!startTime) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
    if (typeof startTime === `object`) return startTime;

    return parseTime(startTime);
  });

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (typeof startTime === `object`) {
      setTimer(startTime);

      return;
    }

    if (!startTime) {
      setTimer({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });

      return;
    }

    setTimer(parseTime(startTime));
  }, [startTime]);

  useEffect(() => {
    const intervalHandle = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer.seconds > 0) {
          return {
            ...prevTimer,
            seconds: prevTimer.seconds - 1,
          };
        }

        if (prevTimer.minutes > 0) {
          return {
            ...prevTimer,
            minutes: prevTimer.minutes - 1,
            seconds: 59,
          };
        }

        if (prevTimer.hours > 0) {
          return {
            ...prevTimer,
            hours: prevTimer.hours - 1,
            minutes: 59,
            seconds: 59,
          };
        }

        if (prevTimer.days > 0) {
          return {
            days: prevTimer.days - 1,
            hours: 23,
            minutes: 59,
            seconds: 59,
          };
        }

        clearInterval(intervalHandle);

        return prevTimer;
      });
    }, 1000);

    return () => {
      clearInterval(intervalHandle);
    };
  }, [startTime]);

  if (!isClient) return <div className="timer-wrapper-empty"></div>;
  // if (true) return <div className="timer-wrapper-empty"></div>;

  return (
    <div className="timer-wrapper">
      <div className="timer-container">
        <div className="counts">{timer.days}</div>
        <div className="description">Day{timer.days !== 1 ? `s` : ``}</div>
      </div>
      <div className="timer-container">
        <div className="counts">{timer.hours}</div>
        <div className="description">
          <span className="short">Hrs</span>
          <span className="long">Hour{timer.hours !== 1 ? `s` : ``}</span>
        </div>
      </div>
      <div className="timer-container">
        <div className="counts">{timer.minutes}</div>
        <div className="description">
          <span className="short">Min</span>
          <span className="long">Minute{timer.minutes !== 1 ? `s` : ``}</span>
        </div>
      </div>
      <div className="timer-container">
        <div className="counts">{Math.floor(timer.seconds)}</div>
        <div className="description">
          <span className="short">Sec</span>
          <span className="long">Second{timer.seconds !== 1 ? `s` : ``}</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
